<section class="cz-create-new-task-dialog-component">
  <mat-dialog-title class="mat-dialog-title">
    <div class="row">
      <div class="col-xs-7">
        <h3 class="title" [innerHTML]="'$common_create_a_task' | translate"></h3>
      </div>
      <div class="col-xs-5 end-xs">
          <button mat-button mat-dialog-close class="mat-dialog-back-button">
              <mat-icon>close</mat-icon>
          </button>
      </div>
    </div>

  </mat-dialog-title>

  <form [formGroup]="taskCreateFormGroup">
    <mat-dialog-content>
      
      <div class="row middle-xs">
        <div class="col-xs-6">
          <mat-form-field class="form-field form-field-full-width">
            <mat-label [innerHTML]="'$common_task_type' | translate"></mat-label>
            <mat-select [formControl]="taskTypeControl" required>
              <mat-option *ngFor="let taskTemplate of taskTemplates" [value]="taskTemplate">{{ taskTemplate.taskName }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-xs-6">
          <mat-checkbox class="form-field"
                        [formControl]="visibleToForUserControl">
            <span [innerHTML]="'$show_to_user_check_label' | translate"></span>
          </mat-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6">
          <mat-form-field class="form-field form-field-full-width">
            <mat-label [innerHTML]="'$common_employee' | translate"></mat-label>
            <input [formControl]="subjectControl" matInput type="text" [matAutocomplete]="autoSubject" required>
            <mat-autocomplete #autoSubject="matAutocomplete" [displayWith]="autocompleteUserOption">
              <mat-option *ngFor="let option of subjectFilteredOptions | async" [value]="option">
                <cz-user-select-item [user]="option"></cz-user-select-item>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="col-xs-6">
          <mat-form-field class="form-field form-field-full-width">
            <mat-label [innerHTML]="'$common_assigned_to' | translate"></mat-label>
            <input [formControl]="assignedToControl" matInput type="text" [matAutocomplete]="autoAssigned" required>
            <mat-autocomplete #autoAssigned="matAutocomplete" [displayWith]="autocompleteUserOption">
              <mat-option *ngFor="let option of assignedToFilteredOptions | async" [value]="option">
                  <cz-user-select-item [user]="option"></cz-user-select-item>
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6">
          <mat-form-field class="form-full-width-field">
            <mat-label [innerHTML]="'$common_select_a_date' | translate"></mat-label>
            <input [formControl]="dueDateControl" matInput [matDatepicker]="dp" required>
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp disabled="false"></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-xs-6">
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$common_time_to_complete' | translate"></mat-label>
            <input [formControl]="hoursControl" matInput required>
            <mat-hint><span [innerHTML]="'$common_hint_example' | translate"></span>: 0.25</mat-hint>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$common_task_summary' | translate"></mat-label>
            <textarea [formControl]="summaryControl" matInput></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$common_task_details' | translate"></mat-label>
            <textarea [formControl]="notesControl" matInput></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 end-xs">
          <p class="font-size-small required-disclaimer">*<span [innerHTML]="'$common_required_field' | translate"></span></p>
        </div>
      </div>
    </mat-dialog-content>
    <mat-actions>
      <div class="row end-xs">
        <p *ngIf="showSurveyTaskError" class="error-msg" [innerHTML]="'$create_a_task_error' | translate"></p>
        <div class="col-xs-2">
          <p><button mat-button class="link" mat-dialog-close [innerHTML]="'$btn_cancel' | translate"></button></p>
        </div>
        <div class="col-xs-2">
          <p><button (click)="createTask()" mat-flat-button class="link" color="accent" [innerHTML]="'$btn_save' | translate"></button></p>
        </div>
      </div>
    </mat-actions>
  </form>
</section>
